import React, { useEffect, useState, forwardRef } from "react"
import NavigationGroup from "../molecules/NavigationGroup"
import { Desktop, Mobile } from "../util/breakpoints"
import * as contentTypes from "../../api/contentTypes"
import { Link } from "../Router"
import useWindowSize from '../util/useWindowSize'
import { forceTrailingSlash } from "../../util/urlTransforms"

export default forwardRef(({ title, navigationGroups, blogCategories, page, onLinkClick }, ref) => {
  const [isOutOfBounds, setOutOfBounds] = useState(false)
  const windowSize = useWindowSize()

  useEffect(() => {
    setTimeout(() => {
      const submenuElem = document.querySelector('.o-submenu')

      if (!submenuElem) return

      const right = submenuElem.getBoundingClientRect().right

      if (right > (windowSize.width || document.documentElement.clientWidth)) {
        setOutOfBounds(true)
      }
    }, 1)
  }, [windowSize])

  // the nav group must contain at least 1 page on this language... not really it could also only contain a page

  navigationGroups = navigationGroups?.filter(navGroup => navGroup.pages && navGroup.pages.some(page => !page.locales));

  const slug = page?.slug ? forceTrailingSlash( page.slug ) : ""
  
  const isExternalLink = page?.contentType && page.contentType === contentTypes.NAVIGATION_ITEM_EXTERNAL_LINK

  return (
    <>
      <Desktop>
        <div
          className={ "o-submenu u-menu-indicator" + (isOutOfBounds ? " u-menu-indicator--right" : " u-menu-indicator--center") }
          ref={ ref }
        >
          { navigationGroups &&
            <div className="o-submenu__cols">
                { 
                  navigationGroups
                    .filter(({ pages }) => pages.length > 0)
                    .map((group, index) => {
                      const containsBlog = group.pages[0].contentType === contentTypes.PAGE_BLOG_ARCHIVE

                      return (
                        <NavigationGroup
                          onLinkClick={ onLinkClick }
                          categories={ containsBlog && blogCategories }
                          { ...group }
                          key={ index }
                        />
                      )
                    }) 
                }
            </div>
          }
          { ( page && !isExternalLink ) &&
            <Link onClick={ onLinkClick } className="o-submenu__read-more u-center-text" to={ `/${slug}` }>
              { page.navigationTitle }
            </Link>
          }
          { ( page && isExternalLink ) &&
            <a href={ page.url } onClick={ onLinkClick } className="o-submenu__read-more u-center-text" target="_blank" rel="noopener noreferrer nofollow" >
              { page.title }
            </a>
          }
        </div>
      </Desktop>
      <Mobile>
        { navigationGroups &&
          <div className="o-submenu__item">
            { navigationGroups.filter(({ pages }) => pages.length > 0).map((group, index) =>
              <NavigationGroup { ...group } key={ index } onLinkClick={ onLinkClick }/>
            )}
          </div>
        }
        { ( page && !isExternalLink ) &&
          <Link onClick={ onLinkClick } className="o-submenu__read-more u-center-text" to={ `/${slug}` }>
            { page.navigationTitle }
          </Link>
        }
        { ( page && isExternalLink ) &&
            <a href={ page.url } onClick={ onLinkClick } className="o-submenu__read-more u-center-text" target="_blank" rel="noopener noreferrer nofollow" >
              { page.title }
            </a>
          }
      </Mobile>
    </>
  )
})
